{
  "brand": {
    "tagline": "La memoria de tu hogar."
  },
  "common": {
    "loading": "Cargando…",
    "retry": "Intentar de nuevo",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "save": "Guardar cambios",
    "optional": "opcional",
    "or": "o",
    "you": "tú",
    "selected": "seleccionado",
    "skipToContent": "Saltar al contenido",
    "notifications": "Notificaciones",
    "edit": "Editar",
    "showMore": "Mostrar más",
    "pagination": "Paginación",
    "previous": "Anterior",
    "next": "Siguiente",
    "pageOf": "Página {{page}} de {{total}}",
    "removedAccount": "Cuenta eliminada",
    "back": "Volver",
    "more": "Más acciones",
    "filters": "Filtros",
    "sort": "Ordenar",
    "add": "Añadir",
    "search": "Buscar",
    "done": "Listo",
    "clear": "Borrar"
  },
  "nav": {
    "main": "Navegación principal",
    "home": "Inicio",
    "house": "Casa",
    "profile": "Menú del perfil",
    "settings": "Configuración",
    "signOut": "Salir",
    "assets": "Equipos",
    "requests": "Solicitudes",
    "account": "Tu cuenta"
  },
  "form": {
    "errorSummaryTitle": {
      "one": "Hay 1 cosa por corregir",
      "other": "Hay {{count}} cosas por corregir"
    }
  },
  "errors": {
    "generic": "Algo salió mal de nuestro lado. Inténtalo de nuevo en un momento.",
    "codes": {
      "network_error": "No pudimos conectar con Lumora. Revisa tu conexión e inténtalo de nuevo.",
      "server_error": "Algo salió mal de nuestro lado. Inténtalo de nuevo en un momento.",
      "request_failed": "No se pudo completar. Inténtalo de nuevo.",
      "unauthenticated": "Tu sesión terminó. Inicia sesión de nuevo para continuar.",
      "forbidden": "No tienes permiso para hacer esto.",
      "not_found": "No encontramos lo que buscabas.",
      "conflict": "Esto cambió mientras tanto. Recarga e inténtalo de nuevo.",
      "version_conflict": "Otra persona cambió esto mientras lo editabas.",
      "csrf_token_mismatch": "Tu sesión expiró. Recarga la página e inténtalo de nuevo.",
      "validation_failed": "Algunos datos necesitan tu atención.",
      "too_many_requests": "Demasiados intentos. Espera {{seconds}} segundos e inténtalo de nuevo.",
      "too_many_requests_nowait": "Demasiados intentos. Espera un momento e inténtalo de nuevo.",
      "invalid_credentials": "El correo o la contraseña no son correctos. Revísalos e inténtalo de nuevo.",
      "email_not_verified": "Confirma primero tu correo. Te enviamos un enlace cuando creaste la cuenta.",
      "email_taken": "Ese correo ya está en uso por otra cuenta.",
      "already_member": "Esa persona ya forma parte de la casa.",
      "invitation_pending": "Ya hay una invitación pendiente para ese correo.",
      "invitation_expired": "Esta invitación expiró. Pide una nueva.",
      "invitation_used": "Esta invitación ya fue usada.",
      "invitation_revoked": "Esta invitación fue cancelada.",
      "invitation_email_mismatch": "Esta invitación se envió a otro correo.",
      "owner_cannot_be_removed": "No se puede quitar al propietario. Transfiere la propiedad antes.",
      "transfer_pending": "Ya hay una transferencia de propiedad esperando respuesta.",
      "last_sign_in_method": "Esta es tu única forma de entrar. Define una contraseña antes de desvincular Google.",
      "verification_token_invalid": "Este enlace expiró o ya fue usado.",
      "password_reset_token_invalid": "Este enlace expiró o ya fue usado. Pide uno nuevo.",
      "idempotency_key_reused": "Esta solicitud ya se envió con datos distintos.",
      "file_too_large": "El archivo es demasiado grande. Las imágenes pueden pesar hasta 20 MB y los PDF hasta 25 MB.",
      "household_storage_quota_exceeded": "Esta casa se quedó sin espacio para archivos. Elimina los que ya no necesites e inténtalo de nuevo.",
      "unsupported_file_type": "Este tipo de archivo no se acepta. Usa una foto (JPEG, PNG, WebP, HEIC) o un PDF.",
      "document_not_ready": "El archivo todavía se está procesando. Inténtalo de nuevo en unos instantes.",
      "category_exists": "Ya existe una categoría con ese nombre.",
      "extraction_quota_exceeded": "Esta casa ya usó todas las lecturas de documentos de este mes. Puedes completar los datos tú mismo.",
      "extraction_disabled": "La lectura de documentos no está disponible por ahora. Puedes completar los datos tú mismo.",
      "request_already_selected": "Ya se eligió otra propuesta en esta solicitud. La página muestra a quién se eligió.",
      "request_not_open": "Esta solicitud no está abierta para esta acción.",
      "request_not_editable": "Esta solicitud ya no puede recibir información compartida nueva.",
      "request_not_cancellable": "Esta solicitud ya no se puede cancelar.",
      "no_published_revision": "Primero comparte la información de la solicitud y luego invita a técnicos.",
      "quote_version_not_current": "Esa propuesta se actualizó mientras tanto. Mira la versión más reciente y elige de nuevo.",
      "quote_needs_reconfirmation": "La información de la solicitud cambió. El técnico debe reconfirmar la propuesta antes de poder elegirla.",
      "quote_expired": "Esta propuesta venció y ya no se puede elegir.",
      "quote_withdrawn": "El técnico retiró esta propuesta.",
      "quote_already_selected": "Esta propuesta ya fue elegida y no se puede retirar.",
      "revision_outdated": "La información de la solicitud cambió. Revísala y envía tu propuesta de nuevo.",
      "technician_verification_required": "Confirma tu correo para continuar.",
      "technician_verification_required_nohint": "Confirma tu correo para continuar.",
      "invitation_bound_to_other_identity": "Este enlace ya lo usa otra persona.",
      "verification_code_invalid": "Ese código no es correcto. Revísalo e inténtalo de nuevo.",
      "verification_code_expired": "Ese código venció. Pide uno nuevo.",
      "verification_attempts_exceeded": "Demasiados intentos fallidos. Pide un código nuevo.",
      "internal_error": "Algo salió mal de nuestro lado. Inténtalo de nuevo en un momento.",
      "owns_households": "Todavía administras casas. Transfiérelas o elimínalas antes.",
      "export_in_progress": "Ya hay una exportación en preparación.",
      "export_not_ready": "La exportación aún no está lista.",
      "export_expired": "Esta exportación expiró. Pide una nueva.",
      "reminder_finished": "Este recordatorio ya está terminado.",
      "service_record_pending": "Ya hay un registro esperando la confirmación del residente.",
      "technician_not_selected": "Solo el prestador elegido puede registrar el servicio.",
      "request_not_selected": "Esta solicitud no tiene un presupuesto elegido.",
      "service_record_not_correctable": "Este registro no espera una corrección.",
      "service_record_not_pending": "Este registro ya no espera confirmación."
    },
    "fields": {
      "required": "Completa este campo.",
      "email": "Escribe un correo válido.",
      "max": "Usa como máximo {{max}} caracteres.",
      "min": "Usa al menos {{min}} caracteres.",
      "unique": "Este valor ya está en uso.",
      "confirmed": "Los dos valores no coinciden.",
      "invalid": "Este valor no es válido.",
      "current_password": "La contraseña actual no es correcta.",
      "in": "Elige una de las opciones disponibles.",
      "timezone": "Elige una zona horaria válida.",
      "exists": "No se encontró este elemento en esta casa.",
      "date": "Introduce una fecha válida.",
      "integer": "Introduce un número entero."
    }
  },
  "states": {
    "error": {
      "title": "No pudimos cargar esto",
      "description": "Algo salió mal de nuestro lado. Inténtalo de nuevo en un momento.",
      "reference": "Referencia",
      "reloadPage": "Recargar la página"
    },
    "forbidden": {
      "title": "No puedes ver esto",
      "description": "No tienes acceso a esta página. Si crees que es un error, habla con el propietario de la casa."
    },
    "offline": {
      "title": "Estás sin conexión",
      "description": "Vuelve a conectarte para ver la información más reciente. No se guardó nada mientras estabas sin conexión.",
      "banner": "Estás sin conexión. Los cambios no se pueden guardar hasta que te reconectes."
    },
    "notFound": {
      "title": "Página no encontrada",
      "description": "El enlace puede estar mal o esta página ya no existe.",
      "action": "Ir al inicio"
    }
  },
  "auth": {
    "fields": {
      "name": "Nombre",
      "email": "Correo electrónico",
      "password": "Contraseña",
      "newPassword": "Nueva contraseña",
      "passwordConfirmation": "Repite la contraseña",
      "passwordHint": "Usa al menos {{min}} caracteres."
    },
    "google": {
      "continue": "Continuar con Google"
    },
    "oauthErrors": {
      "oauth_not_configured": "El acceso con Google no está disponible ahora. Usa tu correo y contraseña.",
      "account_exists_link_required": "Ya existe una cuenta con este correo. Inicia sesión con tu contraseña y vincula Google en Configuración.",
      "oauth_failed": "No pudimos iniciar sesión con Google. Inténtalo de nuevo o usa tu correo y contraseña."
    },
    "login": {
      "title": "Iniciar sesión",
      "description": "Qué bueno verte de nuevo en Lumora.",
      "submit": "Iniciar sesión",
      "remember": "Mantener la sesión en este dispositivo",
      "forgot": "¿Olvidaste tu contraseña?",
      "noAccount": "¿Eres nuevo en Lumora?",
      "createAccount": "Crear una cuenta"
    },
    "register": {
      "title": "Crea tu cuenta",
      "description": "Organiza la información de tu casa en un solo lugar.",
      "submit": "Crear cuenta",
      "haveAccount": "¿Ya tienes una cuenta?",
      "signIn": "Iniciar sesión",
      "agree": "Al crear la cuenta aceptas los Términos de Uso y la Política de Privacidad (enlaces al final de la página)."
    },
    "forgot": {
      "title": "Restablecer la contraseña",
      "description": "Escribe tu correo y te enviaremos un enlace para elegir una nueva contraseña.",
      "submit": "Enviar enlace",
      "sentTitle": "Revisa tu correo",
      "sent": "Si existe una cuenta con este correo, enviamos un enlace para restablecer la contraseña. Puede tardar unos minutos.",
      "back": "Volver a iniciar sesión"
    },
    "reset": {
      "title": "Elige una nueva contraseña",
      "description": "Para la cuenta {{email}}.",
      "submit": "Guardar nueva contraseña",
      "done": "Contraseña cambiada. Inicia sesión con la nueva contraseña.",
      "invalidTitle": "Este enlace no es válido",
      "invalid": "El enlace expiró, ya fue usado o está incompleto. Pide uno nuevo.",
      "requestNew": "Pedir un nuevo enlace"
    }
  },
  "verify": {
    "banner": {
      "badge": "Correo sin confirmar",
      "text": "Confirma {{email}} para invitar personas a tu casa. Te enviamos un enlace.",
      "resend": "Enviar el enlace de nuevo",
      "sent": "Enlace enviado. Revisa tu bandeja de entrada."
    },
    "page": {
      "title": "Confirmando tu correo",
      "checking": "Revisando tu enlace…",
      "successTitle": "Correo confirmado",
      "success": "Gracias. Tu correo fue confirmado.",
      "failedTitle": "No pudimos confirmar tu correo",
      "missing": "Este enlace está incompleto. Abre de nuevo el enlace del correo.",
      "expired": "Este enlace expiró o ya fue usado.",
      "expiredSignedIn": "Puedes pedir un nuevo enlace desde el aviso en la parte superior de la página.",
      "expiredAnonymous": "Inicia sesión para pedir un nuevo enlace.",
      "continue": "Continuar"
    }
  },
  "household": {
    "switcher": {
      "label": "Cambiar de casa",
      "choose": "Elige una casa"
    },
    "onboarding": {
      "title": "Crea tu primera casa",
      "description": "La casa es donde guardas lo que le pertenece y lo compartes con quienes viven contigo.",
      "action": "Crear una casa"
    },
    "new": {
      "title": "Nueva casa",
      "menu": "Crear una casa nueva",
      "description": "Solo el nombre es obligatorio. Completas el resto después.",
      "submit": "Crear casa",
      "created": "{{name}} fue creada."
    },
    "fields": {
      "name": "Nombre de la casa",
      "country": "País",
      "countryNone": "No indicar",
      "currency": "Moneda",
      "currencyHint": "Se usa por defecto para los importes de esta casa.",
      "timezone": "Zona horaria",
      "address": "Dirección",
      "addressHint": "Completa solo lo que tenga sentido donde vives.",
      "line1": "Dirección, línea 1",
      "line2": "Dirección, línea 2",
      "neighborhood": "Barrio o colonia",
      "city": "Ciudad",
      "region": "Estado, provincia o región",
      "postalCode": "Código postal"
    }
  },
  "home": {
    "subtitle": "Lo que necesita de ti en esta casa.",
    "empty": {
      "title": "Nada necesita de ti ahora",
      "description": "Empieza agregando un equipo o pidiendo un presupuesto.",
      "addAsset": "Agregar equipo",
      "askQuote": "Pedir presupuesto"
    },
    "pending": {
      "title": "Pendientes",
      "needsAction": "Necesita tu acción",
      "needsAnswer": "Esperando tu respuesta",
      "waiting": "En curso"
    },
    "verify": {
      "title": "Confirma tu correo",
      "description": "Enviamos un enlace a {{email}}. Con el correo confirmado, puedes invitar personas a tu casa."
    },
    "transfer": {
      "title": "{{name}} quiere transferirte la propiedad de {{household}}",
      "consequence": "Si aceptas, serás el único propietario y el propietario actual pasará a ser miembro.",
      "expires": "Responde hasta el {{date}}.",
      "accept": "Aceptar",
      "decline": "Rechazar",
      "accepted": "Ahora eres el propietario.",
      "declined": "Solicitud rechazada.",
      "confirmTitle": "¿Ser el propietario de {{household}}?",
      "confirmDescription": "Pasarás a gestionar los miembros y la propiedad. {{name}} seguirá en la casa como miembro."
    },
    "invitations": {
      "title": {
        "one": "1 invitación esperando respuesta",
        "other": "{{count}} invitaciones esperando respuesta"
      },
      "description": "Las personas invitadas aún no han entrado. Puedes cancelar una invitación cuando quieras.",
      "action": "Ver invitaciones"
    },
    "outgoing": {
      "title": "Esperando que {{name}} acepte la transferencia de propiedad",
      "action": "Ver transferencia"
    },
    "quotes": {
      "description_one": "{{count}} presupuesto para comparar.",
      "description_other": "{{count}} presupuestos para comparar.",
      "action": "Ver presupuestos"
    },
    "requests": {
      "draft": "Borrador: aún no se comparte con un técnico.",
      "open": "Esperando respuestas de los técnicos.",
      "action": "Abrir solicitud"
    },
    "service": {
      "title": "El servicio en {{asset}} espera tu confirmación",
      "noAsset": "un elemento",
      "by": "Informado por {{name}}",
      "action": "Revisar servicio"
    },
    "reminders": {
      "title": "Recordatorios",
      "all": "Ver todos los recordatorios",
      "none": "Ningún recordatorio próximo. Ver o crear recordatorios"
    },
    "activity": {
      "title": "Actividad reciente",
      "unnamed": "un elemento eliminado",
      "generic": "Hubo actividad en la casa.",
      "asset_created": "Equipo agregado: {{subject}}",
      "asset_archived": "Equipo archivado: {{subject}}",
      "maintenance_created": "Servicio registrado en {{subject}}",
      "maintenance_updated": "Registro de servicio corregido en {{subject}}",
      "service_record_proposed": "El prestador informó un servicio en {{subject}}",
      "service_record_corrected": "El prestador corrigió el servicio en {{subject}}",
      "service_record_correction_requested": "Corrección pedida al prestador en {{subject}}",
      "service_record_confirmed": "Servicio confirmado en {{subject}}",
      "request_created": "Solicitud creada: {{subject}}",
      "request_quote_selected": "Presupuesto elegido en la solicitud {{subject}}",
      "request_cancelled": "Solicitud cancelada: {{subject}}",
      "request_completed": "Solicitud completada: {{subject}}",
      "quote_submitted": "Presupuesto recibido en la solicitud {{subject}}",
      "quote_resubmitted": "Presupuesto actualizado en la solicitud {{subject}}",
      "reminder_completed": "Recordatorio marcado como hecho: {{subject}}",
      "invitation_accepted": "Un nuevo miembro se unió a la casa"
    },
    "greeting": "Hola, {{name}}"
  },
  "house": {
    "title": "Casa",
    "roles": {
      "owner": "Propietario",
      "member": "Miembro"
    },
    "settings": {
      "title": "Datos de la casa",
      "descriptionOwner": "Puedes cambiar estos datos porque eres el propietario.",
      "descriptionMember": "Solo el propietario puede cambiar estos datos.",
      "saved": "Cambios guardados.",
      "conflictTitle": "Alguien cambió esta casa mientras la editabas",
      "conflictDescription": "Tus cambios siguen aquí y no se guardaron. Carga la versión más reciente o conserva tus cambios y guárdalos encima.",
      "conflictReload": "Cargar la versión más reciente",
      "conflictKeep": "Conservar mis cambios y guardar"
    },
    "members": {
      "title": "Miembros",
      "descriptionOwner": "Personas con acceso a esta casa. Quitar a alguien termina su acceso de inmediato.",
      "descriptionMember": "Personas con acceso a esta casa.",
      "joined": "Se unió el {{date}}",
      "remove": "Quitar",
      "removeTitle": "¿Quitar a {{name}}?",
      "removeDescription": "{{name}} pierde el acceso a esta casa de inmediato. Puedes volver a invitar a la persona más tarde.",
      "removeConfirm": "Quitar acceso",
      "removed": "{{name}} fue quitado(a)."
    },
    "invite": {
      "title": "Invitar a alguien",
      "description": "Enviamos la invitación por correo. Sirve para un solo uso y expira en 7 días.",
      "hint": "La persona debe usar este mismo correo para entrar.",
      "submit": "Enviar invitación",
      "sent": "Invitación enviada a {{email}}.",
      "pendingTitle": "Invitaciones esperando respuesta",
      "none": "No hay invitaciones pendientes.",
      "expires": "Expira el {{date}}",
      "status": {
        "pending": "En espera"
      },
      "revoke": "Cancelar invitación",
      "revokeTitle": "¿Cancelar esta invitación?",
      "revokeDescription": "El enlace enviado a {{email}} deja de funcionar de inmediato.",
      "revokeConfirm": "Cancelar invitación",
      "revoked": "Invitación cancelada."
    },
    "ownership": {
      "title": "Propiedad",
      "description": "Transfiere la propiedad de esta casa a otro miembro. Nada cambia hasta que la persona acepte.",
      "start": "Transferir propiedad",
      "sheetTitle": "Transferir propiedad",
      "consequence": "Si el miembro acepta, será el único propietario y tú pasarás a ser miembro. Conservas el acceso, pero ya no gestionas miembros ni la propiedad.",
      "chooseMember": "Nuevo propietario",
      "send": "Enviar solicitud",
      "started": "Solicitud enviada. Nada cambia hasta que sea aceptada.",
      "waiting": "Esperando respuesta",
      "pending": "{{name}} tiene hasta el {{date}} para aceptar la transferencia.",
      "cancel": "Cancelar solicitud",
      "cancelled": "Solicitud cancelada.",
      "noCandidates": "Para transferir la propiedad, invita primero a otra persona y espera a que entre."
    },
    "leave": {
      "title": "Salir de esta casa",
      "description": "Si sales de {{name}}, pierdes el acceso a ella.",
      "action": "Salir de la casa",
      "confirmTitle": "¿Salir de {{name}}?",
      "confirmDescription": "Tu acceso termina de inmediato. Para volver, el propietario debe invitarte de nuevo.",
      "confirm": "Salir de la casa",
      "done": "Saliste de {{name}}."
    },
    "documents": {
      "title": "Documentos",
      "description": "Facturas, manuales y garantías de la casa.",
      "open": "Abrir documentos"
    },
    "delete": {
      "zone": "Zona de peligro",
      "description": "Eliminar la casa termina el acceso de todos de inmediato. Exporta antes si quieres conservar los datos.",
      "open": "Eliminar esta casa",
      "confirmTitle": "¿Eliminar {{name}}?",
      "consequences": "Esta acción no se puede deshacer.",
      "points": {
        "access": "Todos pierden el acceso ahora: miembros y técnicos con enlaces, sin excepción.",
        "purge": "Los datos y archivos se borran definitivamente en un máximo de 30 días.",
        "backups": "Las copias de seguridad expiran según su retención y no se restauran con acceso.",
        "export": "Si necesitas los datos, expórtalos antes."
      },
      "typeName": "Escribe el nombre de la casa para confirmar: {{name}}",
      "password": "Tu contraseña",
      "action": "Eliminar casa",
      "done": "La casa fue eliminada."
    },
    "export": {
      "cardTitle": "Exportar datos",
      "cardDescription": "Descarga una copia de los datos y archivos de la casa.",
      "open": "Exportar",
      "crumb": "Exportación",
      "title": "Exportar datos de la casa",
      "intro": "Genera una copia para guardar o llevar contigo. Solo el owner puede exportar.",
      "includedTitle": "Qué incluye",
      "included": "Equipos, servicios, solicitudes, presupuestos, recordatorios y miembros en JSON y CSV, más los archivos listos, en un ZIP.",
      "excludedTitle": "Qué no incluye",
      "excluded": "Contraseñas, tokens, secretos y datos de otras casas nunca se exportan.",
      "availability": "La exportación está disponible para descargar durante 24 horas y luego se borra.",
      "requestTitle": "Tu exportación",
      "none": "Aún no has pedido ninguna exportación.",
      "request": "Pedir exportación",
      "again": "Pedir nueva exportación",
      "inProgress": "Ya hay una exportación en preparación. Síguela aquí.",
      "ownerOnly": "Solo el owner de la casa puede exportar los datos.",
      "status": {
        "queued": "En cola",
        "processing": "Preparando",
        "ready": "Lista para descargar",
        "failed": "No funcionó",
        "expired": "Expirada"
      },
      "requestedAt": "Pedida el {{date}}",
      "preparing": "Estamos preparando el archivo. Esta página se actualiza sola.",
      "expiresAt": "Disponible hasta {{date}}",
      "download": "Descargar ZIP",
      "failedNote": "La exportación falló. Puedes pedirla de nuevo.",
      "expiredNote": "Terminó el plazo de 24 horas y el archivo se borró. Pide una nueva."
    }
  },
  "invite": {
    "title": "Te invitaron a una casa",
    "description": "{{inviter}} te invitó a formar parte de {{household}} en Lumora.",
    "household": "Casa",
    "invitedBy": "Invitado por",
    "forAddress": "Enviado a",
    "expires": "Válido hasta",
    "signedInAs": "Has iniciado sesión como {{email}}.",
    "signInPrompt": "Inicia sesión o crea una cuenta con el correo invitado para aceptar.",
    "signIn": "Iniciar sesión",
    "createAccount": "Crear una cuenta",
    "accept": "Aceptar invitación",
    "joined": "Te uniste a {{name}}.",
    "useOtherAccount": "Salir y usar otra cuenta",
    "goHome": "Ir al inicio",
    "unavailableTitle": "Esta invitación no está disponible",
    "errors": {
      "invitation_not_found": "No encontramos esta invitación. Revisa el enlace de tu correo.",
      "invitation_expired": "Esta invitación expiró. Pide una nueva al propietario de la casa.",
      "invitation_used": "Esta invitación ya fue usada.",
      "invitation_revoked": "El propietario canceló esta invitación.",
      "invitation_email_mismatch": "Esta invitación se envió a {{hint}}, pero tú iniciaste sesión como {{email}}. Sal y usa el correo invitado.",
      "already_member": "Ya formas parte de esta casa."
    }
  },
  "settings": {
    "title": "Configuración",
    "saved": "Guardado.",
    "notSynced": "Tu elección vale en este dispositivo, pero no pudimos guardarla en tu perfil.",
    "profile": {
      "title": "Perfil"
    },
    "email": {
      "title": "Correo electrónico",
      "verified": "Confirmado",
      "unverified": "Sin confirmar",
      "pending": "Esperando que confirmes {{email}}. Tu correo no cambia hasta que abras el enlace que enviamos allí.",
      "description": "Para cambiar el correo necesitas tu contraseña actual. Enviamos un enlace a la nueva dirección.",
      "newEmail": "Nuevo correo",
      "submit": "Cambiar correo",
      "sent": "Enviamos un enlace a {{email}}. Tu correo cambia cuando lo confirmes.",
      "needPassword": "Define una contraseña abajo para poder cambiar el correo."
    },
    "appearance": {
      "title": "Idioma y apariencia"
    },
    "language": {
      "label": "Idioma"
    },
    "theme": {
      "label": "Tema",
      "light": "Claro",
      "dark": "Oscuro",
      "system": "Igual que el dispositivo"
    },
    "password": {
      "title": "Contraseña",
      "description": "Al cambiar la contraseña, se cierran tus otras sesiones.",
      "setTitle": "Define una contraseña",
      "setDescription": "Tu cuenta aún no tiene contraseña. Con una contraseña también puedes entrar con tu correo.",
      "current": "Contraseña actual",
      "submit": "Cambiar contraseña",
      "setSubmit": "Definir contraseña",
      "changed": "Contraseña guardada."
    },
    "oauth": {
      "title": "Formas de entrar",
      "description": "Puedes mantener tu cuenta de Google vinculada para entrar más rápido.",
      "link": "Vincular cuenta de Google",
      "linked": "Google vinculado",
      "unlink": "Desvincular Google",
      "unlinkTitle": "¿Desvincular Google?",
      "unlinkDescription": "Ya no podrás entrar con Google. Confirma que puedes entrar de otra forma.",
      "unlinked": "Google desvinculado.",
      "notice": {
        "signed_in": "Entraste con Google.",
        "linked": "Tu cuenta de Google quedó vinculada."
      }
    },
    "session": {
      "title": "Sesión"
    },
    "confirmEmail": {
      "title": "Confirmando tu nuevo correo",
      "successTitle": "Correo cambiado",
      "success": "Tu correo ahora es {{email}}.",
      "failedTitle": "No pudimos cambiar tu correo",
      "back": "Volver a configuración"
    },
    "delete": {
      "title": "Eliminar cuenta",
      "description": "Cierra tu cuenta y te quita de las casas. Las casas que administras deben transferirse o eliminarse antes.",
      "open": "Eliminar mi cuenta",
      "confirmTitle": "¿Eliminar tu cuenta?",
      "consequences": "Sales de todas las casas y pierdes el acceso. Tu nombre se quita del historial que mantienen otros miembros: aparece como “Cuenta eliminada”. No se puede deshacer.",
      "password": "Tu contraseña",
      "typeEmail": "Escribe tu correo para confirmar: {{email}}",
      "action": "Eliminar cuenta",
      "ownsTitle": "Todavía administras casas",
      "ownsBody": "Transfiere la propiedad o elimina estas casas y vuelve a intentarlo:",
      "ownsUnnamed": "Abrir casa",
      "goodbyeTitle": "Tu cuenta fue eliminada",
      "goodbyeBody": "Gracias por usar Lumora. Tus datos personales se eliminaron y saliste de todas las casas.",
      "goodbyeAction": "Ir a iniciar sesión"
    },
    "legal": {
      "title": "Acerca de",
      "privacy": "Política de Privacidad",
      "terms": "Términos de Uso"
    }
  },
  "catalog": {
    "title": "Catálogo de componentes",
    "width": "Ancho del marco",
    "syntheticNote": "Solo ejemplos sintéticos. Sin datos reales.",
    "sections": {
      "buttons": "Botones",
      "fields": "Campos",
      "status": "Estado",
      "overlays": "Diálogos y menús",
      "layout": "Diseño",
      "states": "Estados de página",
      "assets": "Elementos de la casa",
      "history": "Historial de servicios",
      "extraction": "Revisión de lectura",
      "upload": "Envío de archivos",
      "warranty": "Garantía",
      "requests": "Compartir y propuestas",
      "technician": "Técnico",
      "m4": "Recordatorios, avisos y confirmaciones",
      "mobile": "Patrones de app (móvil)"
    }
  },
  "money": {
    "hint": "Escríbelo como de costumbre. Ejemplo: {{example}}",
    "currency": "Moneda",
    "errors": {
      "invalid": "No pudimos leer este importe. Usa solo números, con el separador decimal de tu idioma.",
      "too_many_decimals": "Esta moneda admite menos decimales. Corrige el importe; no redondeamos por ti.",
      "too_large": "Este importe es demasiado grande.",
      "negative": "El importe no puede ser negativo."
    }
  },
  "warranty": {
    "valid": "Garantía vigente",
    "expiring_one": "La garantía termina en {{count}} día",
    "expiring_other": "La garantía termina en {{count}} días",
    "endsToday": "La garantía termina hoy",
    "expired": "Garantía vencida",
    "notInformed": "Garantía no informada"
  },
  "history": {
    "by": {
      "you": "Registrado por ti",
      "name": "Registrado por {{name}}",
      "resident": "Registrado por un residente",
      "technician": "Informado por el prestador",
      "removed": "Registrado por una cuenta eliminada"
    },
    "edited": "Editado",
    "status": {
      "pending_confirmation": "Esperando confirmación",
      "correction_requested": "Corrección solicitada",
      "confirmed": "Confirmado por el residente"
    },
    "receipts": "Comprobantes",
    "recordedAt": "Registrado el {{date}}",
    "details": "Ver detalles"
  },
  "assets": {
    "title": "Equipos y áreas",
    "subtitle": "Todo lo que quieres recordar sobre tu casa, en un solo lugar.",
    "add": "Añadir equipo",
    "fromPhoto": "Añadir desde una foto o factura",
    "fromPhotoCrumb": "Desde foto o factura",
    "archivedBadge": "Archivado",
    "kind": {
      "equipment": "Equipo",
      "area": "Área"
    },
    "kindHelp": {
      "equipment": "Un aparato o artículo, como una nevera o una bomba.",
      "area": "Un espacio de la casa, como el tejado o el jardín."
    },
    "count_one": "{{formatted}} elemento",
    "count_other": "{{formatted}} elementos",
    "search": {
      "label": "Buscar",
      "placeholder": "Nombre, marca, modelo o estancia"
    },
    "sort": {
      "label": "Ordenar por",
      "name": "Nombre (A–Z)",
      "-name": "Nombre (Z–A)",
      "-updated_at": "Actualizados recientemente",
      "updated_at": "Actualizados hace más tiempo"
    },
    "filters": {
      "title": "Filtros",
      "kind": "Tipo",
      "kindAll": "Equipos y áreas",
      "category": "Categoría",
      "categoryAll": "Todas las categorías",
      "room": "Estancia",
      "roomAll": "Todas las estancias",
      "archived": "Mostrar solo los archivados",
      "all": "Todos",
      "equipment": "Equipos",
      "areas": "Áreas"
    },
    "empty": {
      "title": "Aún no hay nada",
      "description": "Añade un equipo para guardar su marca, modelo, garantía, fotos y servicios en un solo lugar. Basta con el nombre para empezar."
    },
    "noResults": {
      "title": "Sin resultados",
      "description": "Nada coincide con esta búsqueda o estos filtros.",
      "clear": "Borrar búsqueda y filtros"
    },
    "categories": {
      "refrigerator": "Nevera o congelador",
      "washer": "Lavadora",
      "dryer": "Secadora o lavasecadora",
      "dishwasher": "Lavavajillas",
      "cooking": "Cocina, placa u horno",
      "microwave": "Microondas",
      "hvac": "Climatización y ventilación",
      "electronics": "TV, audio y electrónica",
      "water_heater": "Calentadores",
      "filters": "Filtros y purificadores",
      "pumps": "Bombas",
      "garden_pool": "Jardín y piscina",
      "small_appliances": "Pequeños electrodomésticos",
      "electrical": "Electricidad",
      "plumbing": "Fontanería",
      "roof": "Tejado",
      "other": "Otros"
    },
    "fields": {
      "name": "Nombre",
      "category": "Categoría",
      "categoryNone": "Sin categoría",
      "categoryNew": "Crear una categoría nueva…",
      "categoryName": "Nombre de la categoría nueva",
      "categoryCreate": "Crear categoría",
      "room": "Estancia",
      "roomHint": "Escribe libremente, por ejemplo “Cocina”. Sugerimos las que ya usaste.",
      "brand": "Marca",
      "model": "Modelo",
      "serial": "Número de serie",
      "purchaseDate": "Fecha de compra",
      "price": "Importe pagado",
      "seller": "Vendedor o tienda",
      "warrantyUntil": "Fin de la garantía",
      "warrantyHint": "Indícalo solo si lo sabes. No calculamos la garantía por ti.",
      "warrantyReminder": "Quiero un aviso 30 días antes del fin",
      "notes": "Observaciones"
    },
    "form": {
      "newTitle": "Nuevo equipo o área",
      "editTitle": "Editar",
      "newCrumb": "Nuevo",
      "editCrumb": "Editar",
      "newIntro": "Solo el nombre es obligatorio. El resto lo completas cuando quieras.",
      "fromPhotoLink": "¿Prefieres empezar con una foto de la etiqueta o de la factura?",
      "identification": "Identificación",
      "kind": "¿Qué es?",
      "product": "Producto",
      "purchase": "Compra y garantía",
      "notes": "Anotaciones",
      "photo": "Foto",
      "photoHint": "Ayuda a reconocer el elemento. No es obligatoria.",
      "photoUploadHint": "Sube una foto del equipo o del área.",
      "removePhoto": "Quitar foto",
      "attachedFile": "Archivo que se guardará con el elemento: {{name}}",
      "useAsCover": "Usar esta foto como foto del equipo",
      "waitUpload": "Espera a que termine el envío del archivo para guardar.",
      "create": "Crear",
      "created": "Equipo creado.",
      "createdNoFile": "Creado, pero no pudimos adjuntar el archivo. Súbelo de nuevo en la página del elemento.",
      "saved": "Cambios guardados.",
      "conflictTitle": "Alguien cambió esto mientras editabas",
      "conflictDescription": "Tus cambios siguen aquí y no se guardaron. Carga la versión más reciente o conserva tus cambios y guarda encima.",
      "conflictReload": "Cargar la versión más reciente",
      "conflictKeep": "Conservar mis cambios y guardar"
    },
    "detail": {
      "history": "Historial de servicios",
      "historyEmpty": {
        "title": "Ningún servicio registrado",
        "description": "Registra mantenimientos y reparaciones para saber después qué se hizo, cuándo y quién."
      },
      "documents": "Documentos",
      "documentsEmpty": "Ningún documento vinculado a este elemento.",
      "addDocument": "Subir otro documento",
      "unlink": "Desvincular",
      "unlinkTitle": "¿Desvincular este documento?",
      "unlinkDescription": "Deja de aparecer en este elemento, pero sigue guardado en los documentos de la casa.",
      "identification": "Identificación",
      "identificationEmpty": "Aún no hay marca, modelo ni número de serie. Puedes completarlos cuando quieras.",
      "warranty": "Garantía",
      "warrantyUntil": "Hasta {{date}}, según lo indicado por ti",
      "warrantyNote": "Solo mostramos la garantía que tú indiques.",
      "notes": "Observaciones",
      "enlarge": "Ampliar foto",
      "enlargeShort": "Ampliar",
      "photoAlt": "Foto de {{name}}",
      "copy": "Copiar",
      "copiedShort": "Copiado",
      "copySerial": "Copiar número de serie",
      "copied": "Número de serie copiado.",
      "copyFailed": "No se pudo copiar. Selecciona el texto y cópialo tú mismo.",
      "readDocument": "Leer etiqueta o factura",
      "archivedNote": "Este elemento está archivado. El historial y los documentos se conservan.",
      "archiveTitle": "Archivar",
      "archiveDescription": "Archivar quita el elemento de la lista principal. El historial de servicios y los documentos se conservan y puedes restaurarlo después.",
      "archive": "Archivar",
      "archived": "Elemento archivado.",
      "archiveConfirmTitle": "¿Archivar “{{name}}”?",
      "archiveConfirmDescription": "El elemento sale de la lista principal, pero el historial de servicios y los documentos siguen guardados. Puedes restaurarlo cuando quieras.",
      "restoreTitle": "Restaurar",
      "restoreDescription": "Devuelve el elemento a la lista principal.",
      "restore": "Restaurar",
      "restored": "Elemento restaurado.",
      "reminders": "Recordatorios",
      "remindersAll": "Ver todos",
      "remindersNew": "Nuevo recordatorio",
      "remindersEmpty": "Ningún recordatorio activo para este elemento.",
      "addPhoto": "Agregar foto",
      "changePhoto": "Cambiar foto",
      "photoSaved": "Foto del equipo actualizada"
    }
  },
  "services": {
    "register": "Registrar servicio",
    "intro": "Anota lo que se hizo, aunque no hayas pedido presupuesto aquí.",
    "editTitle": "Corregir registro",
    "editIntro": "Al guardar, conservamos la versión anterior. El registro aparecerá como editado.",
    "detailCrumb": "Servicio",
    "save": "Guardar servicio",
    "saved": "Servicio registrado.",
    "updated": "Registro corregido.",
    "conflict": "Otra persona cambió este registro. Tus cambios siguen aquí y no se guardaron.",
    "readOnlyTechnician": "Este registro lo informó el prestador y no se puede editar aquí.",
    "fields": {
      "asset": "Equipo o área",
      "assetChoose": "Elige un elemento",
      "date": "Fecha del servicio",
      "description": "Qué se hizo",
      "descriptionHint": "Por ejemplo: cambio de filtro y limpieza general.",
      "provider": "Prestador",
      "parts": "Piezas",
      "cost": "Importe pagado",
      "warrantyUntil": "Garantía del servicio hasta",
      "warrantyHint": "Indícalo solo si el prestador dio una garantía.",
      "warrantyNotes": "Condiciones de la garantía"
    },
    "documents": {
      "title": "Comprobantes",
      "hint": "Adjunta facturas, recibos o fotos. Hasta {{max}} archivos.",
      "pick": "Elegir entre los documentos de la casa",
      "remove": "Quitar {{name}}",
      "full": "Límite de {{max}} archivos alcanzado.",
      "none": "Ningún comprobante adjunto."
    },
    "pick": {
      "title": "Documentos de la casa",
      "description": "Marca los que quieras adjuntar. Aún caben {{count}}.",
      "none": "No hay otros documentos listos para adjuntar.",
      "add_one": "Adjuntar {{count}} documento",
      "add_other": "Adjuntar {{count}} documentos"
    },
    "revisions": {
      "title": "Correcciones",
      "description": "Cada edición conserva la versión anterior para que veas qué cambió.",
      "show_one": "Ver la versión anterior",
      "show_other": "Ver las {{count}} versiones anteriores",
      "entry": "Versión {{version}} · sustituida el {{when}} por {{name}}",
      "previous": "Valores anteriores",
      "unknown": "alguien de la casa"
    },
    "review": {
      "title": "Servicio informado por el prestador",
      "confirm": "Confirmar servicio",
      "askCorrection": "Pedir corrección",
      "confirmTitle": "¿Confirmar este servicio?",
      "confirmBody": "Al confirmar, el servicio entra en el historial del elemento y la solicitud queda completada.",
      "notCertification": "La confirmación es tuya, del residente: no es una certificación técnica independiente del trabajo.",
      "confirmAction": "Confirmar servicio",
      "confirmed": "Servicio confirmado. La solicitud está completada.",
      "correctionTitle": "Pedir corrección al prestador",
      "correctionBody": "El prestador verá el motivo y podrá reenviar el registro.",
      "reason": "¿Qué hay que corregir?",
      "correctionAction": "Enviar pedido de corrección",
      "correctionSent": "Pedido de corrección enviado.",
      "waitingCorrection": "Esperando la corrección del prestador",
      "yourReason": "Motivo indicado: {{reason}}",
      "stale": "Este registro cambió mientras mirabas. Actualizamos la pantalla: revísalo e inténtalo de nuevo.",
      "noneYet": "El prestador aún no informó el trabajo realizado.",
      "completedTitle": "Solicitud completada",
      "completedBody": "Confirmaste el servicio y está en el historial del elemento.",
      "seeHistory": "Ver el historial del elemento",
      "confirmedBy": "Confirmado por el residente {{name}} el {{date}}."
    }
  },
  "documents": {
    "kinds": {
      "photo": "Foto",
      "label": "Foto de la etiqueta",
      "invoice": "Factura",
      "receipt": "Recibo o comprobante",
      "manual": "Manual",
      "warranty": "Documento de garantía",
      "other": "Otro"
    },
    "status": {
      "ready": "Listo",
      "processing": "Procesando",
      "rejected": "Rechazado"
    },
    "notReadyYet": "Subido, pero aún no está listo. Podrás abrirlo cuando termine de procesarse.",
    "rejection": {
      "unsupported_file_type": "El contenido del archivo no es de un tipo aceptado. Usa una foto (JPEG, PNG, WebP, HEIC) o un PDF.",
      "file_too_large": "El archivo es demasiado grande.",
      "corrupted_file": "No pudimos abrir el archivo. Puede estar dañado.",
      "encrypted_pdf": "Este PDF tiene contraseña. Sube una versión sin contraseña.",
      "too_many_pages": "Este PDF tiene demasiadas páginas. Sube solo las páginas necesarias.",
      "processing_failed": "No pudimos procesar el archivo. Inténtalo de nuevo."
    },
    "pages_one": "{{count}} página",
    "pages_other": "{{count}} páginas",
    "uploadedBy": "subido por {{name}}",
    "open": "Abrir",
    "opensInNewTab": "(se abre en otra pestaña)",
    "download": "Descargar",
    "added": "Documento añadido.",
    "untitled": "Documento sin nombre",
    "upload": {
      "choose": "Elegir archivo",
      "chooseAnother": "Elegir otro archivo",
      "camera": "Hacer una foto",
      "hint": "Foto (JPEG, PNG, WebP, HEIC) o PDF. Hasta 20 MB para imágenes y 25 MB para PDF.",
      "kindLabel": "Tipo de documento",
      "uploading": "Subiendo archivo",
      "uploadingProgress": "Subiendo… {{percent}}%",
      "processing": "Procesando el archivo…",
      "processingExplain": "El archivo se subió, pero solo podrá usarse cuando esté listo.",
      "processingSlow": "Está tardando más de lo normal. Puedes seguir esperando o volver después; el archivo sigue procesándose.",
      "another": "Subir otro archivo",
      "rejectedTitle": "No se pudo usar este archivo",
      "errorTitle": "No se pudo subir",
      "sensitiveNote": "Las etiquetas, facturas y recibos pueden mostrar número de serie, nombre o dirección. El archivo queda privado en tu casa y puedes quitarlo cuando quieras.",
      "client": {
        "unsupported_file_type": "Este tipo de archivo no se acepta. Usa una foto (JPEG, PNG, WebP, HEIC) o un PDF.",
        "file_too_large": "El archivo es demasiado grande. Las imágenes pueden pesar hasta 20 MB y los PDF hasta 25 MB.",
        "empty_file": "El archivo está vacío."
      }
    },
    "library": {
      "title": "Documentos de la casa",
      "subtitle": "Facturas, manuales, garantías y fotos guardados con privacidad.",
      "add": "Añadir documento",
      "search": "Buscar por nombre",
      "allKinds": "Todos los tipos",
      "asset": "Equipo o área",
      "allAssets": "Todos",
      "selectedAsset": "Elemento seleccionado",
      "sortNewest": "Más recientes",
      "sortOldest": "Más antiguos",
      "sortTitle": "Nombre (A–Z)",
      "noResults": "No se encontraron documentos",
      "emptyTitle": "Aún no hay documentos",
      "emptyDescription": "Guarda aquí facturas, manuales y garantías para encontrarlos cuando los necesites.",
      "count_one": "{{formatted}} documento",
      "count_other": "{{formatted}} documentos"
    },
    "edit": {
      "action": "Renombrar o reclasificar",
      "title": "Renombrar o reclasificar",
      "description": "Solo cambian el nombre y el tipo; el archivo no se modifica.",
      "name": "Nombre",
      "originalName": "Archivo original: {{name}}",
      "saved": "Documento actualizado.",
      "conflict": "Otra persona cambió este documento. Ciérralo y ábrelo de nuevo para ver la versión más reciente."
    },
    "delete": {
      "action": "Eliminar",
      "title": "¿Eliminar este documento?",
      "description": "El acceso al archivo termina ahora, para todos en la casa, y deja de aparecer en los elementos. El archivo se elimina del almacenamiento un poco después.",
      "confirm": "Eliminar documento",
      "done": "Documento eliminado."
    }
  },
  "extraction": {
    "titleCreate": "Añadir desde una foto o factura",
    "titleUpdate": "Leer etiqueta o factura",
    "introCreate": "Sube la foto de la etiqueta, del propio equipo o la factura. Te sugerimos los datos y tú decides qué aceptar.",
    "introUpdate": "Sube o elige un archivo. Las sugerencias solo cambian el elemento si las aceptas.",
    "whatIs": "¿Qué vas a subir?",
    "task": {
      "label": "Foto de la etiqueta",
      "receipt": "Factura o recibo",
      "item": "Foto del equipo"
    },
    "taskHelp": {
      "label": "La etiqueta con marca, modelo y número de serie.",
      "receipt": "Muestra tienda, fecha e importe de la compra.",
      "item": "¿Sin etiqueta o difícil de alcanzar? Intentamos reconocer qué es y la marca, si se ve."
    },
    "nameOptional": "Nombre del equipo",
    "nameOptionalHint": "Si ya lo sabes. Lo guardamos por si la lectura no funciona.",
    "uploadHint": "Foto (JPEG, PNG, WebP, HEIC) o PDF.",
    "useExisting": "O usa un archivo que ya está en este elemento",
    "useThis": "Usar este",
    "manualInstead": "Prefiero rellenarlo yo",
    "backToAsset": "Volver al elemento",
    "consentTitle": "Antes de leer el documento",
    "consent": "Solo este archivo se enviará a {{provider}} para su lectura.",
    "consentFine": "No se envía ninguna otra información de tu casa. Nada cambia sin tu aceptación.",
    "quota": "Has usado {{used}} de {{limit}} lecturas este mes.",
    "allow": "Permitir y leer el documento",
    "fillManually": "Rellenar manualmente",
    "quotaReachedTitle": "Lecturas del mes agotadas",
    "quotaReached": "Esta casa ya usó las {{limit}} lecturas de este mes.",
    "disabledTitle": "Lectura no disponible",
    "disabled": "La lectura de documentos está desactivada por el momento.",
    "manualStillWorks": "El archivo está guardado y el registro manual sigue funcionando.",
    "reading": "Leyendo el documento…",
    "readingHint": "Puede tardar unos segundos.",
    "failedTitle": "No pudimos leer el documento",
    "failedKept": "El archivo está guardado. Puedes seguir rellenando los datos tú mismo.",
    "errors": {
      "provider_unavailable": "El servicio de lectura no está disponible ahora.",
      "provider_timeout": "La lectura tardó demasiado y se detuvo.",
      "invalid_provider_output": "No pudimos entender el resultado de la lectura.",
      "unsupported_document": "Este tipo de documento no se puede leer.",
      "document_too_large": "El documento es demasiado grande para leerse.",
      "timeout": "La lectura está tardando más de lo normal.",
      "generic": "No pudimos leer el documento ahora."
    },
    "review": {
      "intro": "Son sugerencias. No se aplica nada hasta que aceptes, campo por campo, y puedes editar antes.",
      "current": "Valor actual",
      "empty": "Vacío",
      "suggestion": "Sugerencia",
      "accept": "Usar este valor",
      "accepted": "Valor aceptado",
      "nameHint": "Obligatorio. Elige una sugerencia o escribe la tuya.",
      "nameSuggestions": "Sugerencias de nombre:",
      "read": "Leído en el documento: {{value}}",
      "readRaw": "Leído en el documento: {{amount}} {{currency}}. Confirma el importe abajo."
    },
    "notFound": {
      "name": "No identificamos un nombre. Puedes rellenarlo ahora o después.",
      "category": "No identificamos la categoría. Puedes elegirla ahora o después.",
      "brand": "No identificamos la marca. Puedes rellenarla ahora o después.",
      "model": "No identificamos el modelo. Puedes rellenarlo ahora o después.",
      "serial_number": "No identificamos el número de serie. Puedes rellenarlo ahora o después.",
      "seller": "No identificamos la tienda. Puedes rellenarla ahora o después.",
      "purchase_date": "No identificamos la fecha de compra. Puedes rellenarla ahora o después.",
      "price": "No identificamos el importe. Puedes rellenarlo ahora o después."
    },
    "createWith": "Crear equipo con lo que acepté",
    "applyAccepted": "Aplicar lo que acepté",
    "updated": "Elemento actualizado.",
    "conflict": "Otra persona cambió este elemento. Recarga los datos actuales y confirma de nuevo.",
    "conflictReload": "Recargar datos actuales"
  },
  "requests": {
    "title": "Solicitudes",
    "subtitle": "Pide presupuestos a técnicos y compara sus respuestas.",
    "ask": "Pedir presupuesto",
    "noItem": "Sin elemento vinculado",
    "unpublished": "Hay cambios sin compartir",
    "unpublishedShort": "Sin compartir",
    "updatedAt": "Actualizado el {{date}}",
    "count_one": "{{formatted}} solicitud",
    "count_other": "{{formatted}} solicitudes",
    "counts": {
      "invitations_one": "{{count}} técnico invitado",
      "invitations_other": "{{count}} técnicos invitados",
      "quotes_one": "{{count}} propuesta",
      "quotes_other": "{{count}} propuestas"
    },
    "status": {
      "draft": "Borrador",
      "open": "Esperando respuesta",
      "selected": "Elegida",
      "completed": "Completada",
      "cancelled": "Cancelada"
    },
    "filters": {
      "status": "Estado",
      "statusAll": "Todos los estados",
      "asset": "Equipo o área",
      "assetAll": "Todos los elementos",
      "sort": "Ordenar por"
    },
    "sort": {
      "-updated_at": "Actualizadas recientemente",
      "-created_at": "Más nuevas primero",
      "created_at": "Más antiguas primero"
    },
    "empty": {
      "title": "Aún no hay solicitudes",
      "description": "Empieza una solicitud cuando algo necesite a un técnico. Tú eliges qué compartir y cada técnico recibe su propio enlace."
    },
    "noResults": {
      "title": "Ninguna solicitud con estos filtros",
      "description": "Prueba con otro estado u otro elemento.",
      "clear": "Quitar filtros"
    },
    "fields": {
      "title": "¿Qué necesitas?",
      "titleHint": "Un título corto, por ejemplo “El refrigerador no enfría”.",
      "description": "Descripción",
      "symptoms": "Qué está pasando",
      "symptomsHint": "Ruidos, códigos de error, desde cuándo ocurre.",
      "availability": "¿Cuándo pueden visitarte?",
      "availabilityHint": "Texto libre, por ejemplo “por las mañanas, entre semana”. Lumora no agenda visitas.",
      "neighborhood": "Barrio",
      "city": "Ciudad",
      "locationHint": "Opcional. Solo se comparte si tú lo eliges. Tu dirección completa nunca se comparte.",
      "currency": "Moneda de las propuestas",
      "currencyHint": "Los técnicos presupuestan en esta moneda.",
      "currencyLocked": "La moneda no puede cambiar después de compartir la solicitud."
    },
    "new": {
      "title": "Nueva solicitud",
      "intro": "Tres pasos cortos: el elemento, el problema y lo que verá el técnico.",
      "fromIntro": "Revisa la información copiada de la solicitud anterior y elige qué compartir.",
      "steps": "Pasos",
      "step": {
        "item": "Elemento",
        "problem": "Problema",
        "share": "Compartir"
      },
      "next": "Continuar",
      "nextShare": "Continuar a compartir",
      "back": "Volver",
      "item": {
        "title": "¿Qué elemento necesita ayuda?",
        "hint": "También puedes empezar sin elemento y vincularlo después.",
        "mode": {
          "existing": "Un elemento que ya registré",
          "new": "Registrar un elemento nuevo ahora",
          "none": "Todavía no tengo un elemento"
        },
        "modeHint": {
          "existing": "Elígelo entre tus equipos y áreas.",
          "new": "Bastan unos pocos datos.",
          "none": "Puedes describir el problema sin vincular un elemento."
        },
        "pick": "Equipo o área",
        "pickChoose": "Elige…",
        "newHint": "Lo registraremos en tu casa para que quede guardado."
      },
      "problem": {
        "title": "Describe el problema",
        "noItem": "Ningún elemento vinculado a esta solicitud.",
        "newItem": "Se registrará un elemento nuevo: {{name}}.",
        "withItem": "Elemento: {{name}}"
      },
      "share": {
        "title": "Lo que verá el técnico",
        "intro": "No se comparte nada hasta que publiques. Elige abajo y revisa la vista previa."
      },
      "progress": "Paso {{current}} de {{total}} · {{name}}"
    },
    "share": {
      "publish": "Publicar y continuar",
      "publishUpdate": "Compartir la información actualizada",
      "publishTitle": "Elige qué compartir",
      "updateTitle": "Actualizar la información compartida",
      "updateIntro": "Elige lo que verán los técnicos en la nueva versión.",
      "updateNote": "Los técnicos invitados recibirán un aviso de la actualización y las propuestas ya enviadas tendrán que reconfirmarse antes de que puedas elegir una.",
      "published": "Solicitud compartida (versión {{number}}).",
      "sendFailed": "No se pudo enviar. Tu borrador se conservó. Inténtalo de nuevo.",
      "conflict": "Esta solicitud se cambió en otro lugar. Recárgala para ver la versión más reciente y publica de nuevo.",
      "reload": "Recargar la solicitud",
      "notEditable": "Esta solicitud ya no acepta información compartida nueva."
    },
    "detail": {
      "fields": "Datos de la solicitud",
      "saved": "Solicitud actualizada.",
      "editNote": "Los cambios quedan solo contigo hasta que vuelvas a compartirlos.",
      "conflict": "Alguien cambió esta solicitud mientras la editabas. Recarga la página para ver la versión más reciente.",
      "location": "Barrio y ciudad",
      "publish": "Elegir qué compartir y publicar",
      "updateShared": "Actualizar la información compartida",
      "unpublishedTitle": "Hay cambios sin compartir",
      "unpublishedBody": "Los técnicos siguen viendo la versión anterior. Al actualizar la información compartida se les avisa y sus propuestas deberán reconfirmarse.",
      "nextStep": "Siguiente paso: crea un enlace para cada técnico de quien quieras recibir respuesta.",
      "quotes": {
        "title": "Propuestas",
        "compare": "Comparar propuestas",
        "empty": "Aún no hay propuestas. Los técnicos responden desde su propio enlace."
      },
      "revisions": {
        "title": "Versiones compartidas",
        "number": "Versión {{number}}",
        "current": "Actual",
        "view": "Ver exactamente lo que se compartió",
        "item": "Datos del elemento",
        "documents_one": "{{count}} documento",
        "documents_other": "{{count}} documentos",
        "records_one": "{{count}} registro de servicio",
        "records_other": "{{count}} registros de servicio",
        "location": "barrio y ciudad"
      }
    },
    "invitations": {
      "title": "Técnicos",
      "intro": "Cada técnico recibe un enlace individual. Puedes revocarlo cuando quieras.",
      "needsPublish": "Publica primero la solicitud para invitar a técnicos.",
      "closed": "Esta solicitud no acepta más técnicos.",
      "empty": "Aún no has invitado a ningún técnico.",
      "unnamed": "Técnico sin nombre",
      "status": {
        "active": "Enlace activo",
        "revoked": "Enlace revocado",
        "expired": "Enlace vencido"
      },
      "verified": "Identidad verificada",
      "notVerified": "Aún sin verificar",
      "quoteYes": "Propuesta recibida",
      "quoteNo": "Sin propuesta",
      "expires": "Enlace válido hasta",
      "viewed": "Última vez visto",
      "notViewed": "Aún no lo ha visto",
      "identity": "Identidad verificada",
      "newLink": "Generar un enlace nuevo",
      "revoke": "Revocar acceso",
      "revoked": "Acceso revocado.",
      "revokeTitle": "¿Revocar el acceso de {{name}}?",
      "revokeDescription": "El técnico pierde el acceso de inmediato. Los archivos ya descargados no se pueden recuperar.",
      "rotateTitle": "¿Generar un enlace nuevo para {{name}}?",
      "rotateDescription": "El enlace anterior deja de funcionar. Envía el enlace nuevo al mismo técnico.",
      "create": {
        "open": "Crear un enlace para un técnico",
        "title": "Nuevo enlace de técnico",
        "description": "El enlace abre solo lo que elegiste compartir.",
        "label": "Nombre privado",
        "labelHint": "Solo lo ves tú, por ejemplo “El electricista de Juan”.",
        "email": "Correo del técnico",
        "emailHint": "Si lo completas, enviamos el enlace por correo y solo esa dirección podrá verificarse.",
        "locale": "Idioma del técnico",
        "localeHint": "El técnico puede cambiarlo en la página.",
        "days": "Validez (días)",
        "daysInvalid": "Usa un número entero de 1 a 60.",
        "submit": "Crear enlace"
      },
      "link": {
        "title": "Enlace listo",
        "description": "Envíaselo tú mismo al técnico, por ejemplo en un mensaje. Lumora no lo envía automáticamente.",
        "label": "Enlace del técnico",
        "copy": "Copiar enlace",
        "copiedShort": "Copiado",
        "copied": "Enlace copiado.",
        "copyFailed": "No se pudo copiar. Selecciona el enlace y cópialo manualmente.",
        "share": "Compartir",
        "shareTitle": "Solicitud de presupuesto",
        "shareText": "Aquí está la información para el presupuesto:",
        "once": "Este enlace se muestra solo ahora y no se podrá mostrar de nuevo. Si lo pierdes, genera uno nuevo y el anterior dejará de funcionar.",
        "emailed": "También enviamos este enlace por correo a {{email}}.",
        "done": "Listo"
      }
    },
    "selection": {
      "quoteSelected": "Propuesta elegida",
      "visitRequested": "Visita solicitada",
      "requestCancelled": "Solicitud cancelada",
      "quoteTitle": "Propuesta elegida: {{name}}",
      "visitTitle": "Visita solicitada: {{name}}",
      "on": "Elegida el {{date}}",
      "by": "por {{name}}",
      "quoteNote": "Elegiste esta propuesta. Las condiciones finales se siguen acordando con el proveedor.",
      "visitNote": "Pediste una visita de evaluación. Esto no es la aceptación de un precio final.",
      "disclaimer": "Elegir no es un contrato ni un pago. Las condiciones finales y la ejecución se acuerdan directamente con el proveedor.",
      "seeQuote": "Ver la propuesta",
      "switchNote": "Para trabajar con otro técnico, cancela esta solicitud y crea una nueva. El historial de esta elección se conserva.",
      "createFromThis": "Crear una solicitud nueva con la misma información"
    },
    "cancel": {
      "title": "Cancelar solicitud",
      "description": "Se avisa a los técnicos y sus enlaces dejan de ser útiles. El historial se conserva.",
      "descriptionDraft": "Este borrador se cancelará. No se compartió nada con técnicos.",
      "descriptionSelected": "Ya se eligió a un técnico. Cancelar conserva el historial y la elección, avisa al técnico y exige un motivo.",
      "action": "Cancelar solicitud",
      "confirmTitle": "¿Cancelar esta solicitud?",
      "confirm": "Se avisará a los técnicos. El historial y las propuestas recibidas se conservan.",
      "confirmSelected": "Se avisará al técnico elegido. El historial, las propuestas y la elección se conservan.",
      "reason": "Motivo",
      "reasonRequired": "Indica el motivo: se comparte con el técnico.",
      "reasonLabel": "Motivo",
      "keep": "Mantener la solicitud",
      "done": "Solicitud cancelada.",
      "cancelledTitle": "Esta solicitud fue cancelada",
      "history": "El historial se conserva y se avisa a los técnicos."
    }
  },
  "share": {
    "privacy": {
      "title": "El técnico verá solo la información seleccionada abajo.",
      "body": "Tu dirección completa nunca se comparte. Los documentos están desactivados hasta que los elijas."
    },
    "item": {
      "title": "Datos del elemento",
      "hint": "El nombre y la categoría de “{{name}}” siempre se comparten. Elige el resto.",
      "none": "No hay un elemento vinculado, así que no se comparten datos de elemento.",
      "notInformed": "No informado",
      "fields": {
        "brand": "Marca",
        "model": "Modelo",
        "serial_number": "Número de serie",
        "room": "Ambiente",
        "purchase_date": "Fecha de compra",
        "warranty_until": "Fin de la garantía"
      }
    },
    "location": {
      "title": "Ubicación",
      "include": "Compartir barrio y ciudad",
      "empty": "Completa el barrio o la ciudad en el paso del problema para poder compartirlos.",
      "neverAddress": "Tu dirección completa nunca se comparte."
    },
    "documents": {
      "title": "Documentos",
      "hint": "Elige hasta {{max}} documentos que el técnico podrá abrir. Solo aparecen archivos listos.",
      "sensitive": "Las facturas, los manuales y las fotos de etiquetas pueden contener datos personales. Están desactivados hasta que los elijas.",
      "sensitiveKind": {
        "label": "Las etiquetas pueden contener información sensible",
        "invoice": "Las facturas pueden contener datos personales",
        "receipt": "Los recibos pueden contener datos personales"
      },
      "none": "No hay documentos listos para este elemento.",
      "full": "Llegaste al límite de {{max}} documentos.",
      "pickMore": "Agregar un documento de la casa"
    },
    "records": {
      "title": "Historial de servicios",
      "hint": "Elige hasta {{max}} servicios anteriores que ayuden al técnico.",
      "none": "No hay servicios registrados para este elemento."
    },
    "picker": {
      "title": "Documentos de la casa",
      "description": "Elige archivos para ponerlos a disposición del técnico.",
      "none": "No hay otros documentos listos.",
      "add_one": "Agregar {{count}} documento",
      "add_other": "Agregar {{count}} documentos"
    },
    "preview": {
      "title": "Lo que verá el técnico",
      "technicianSees": "Esto es exactamente lo que recibe el técnico con tus elecciones actuales.",
      "loading": "Preparando la vista previa…",
      "expiry": "Cada enlace de técnico tiene su propia validez y puedes revocarlo cuando quieras."
    },
    "snapshot": {
      "title": "Información compartida",
      "problem": "Problema",
      "symptoms": "Qué está pasando",
      "item": "Elemento",
      "noItem": "No se compartieron datos de elemento.",
      "where": "Ubicación y disponibilidad",
      "noLocation": "Ubicación no compartida",
      "availability": "Disponibilidad",
      "history": "Historial de servicios",
      "documents": "Documentos",
      "source": {
        "resident": "Registrado por el residente",
        "technician": "Informado por el proveedor"
      }
    }
  },
  "quotes": {
    "title": "Propuestas",
    "intro": "Lee las condiciones de cada propuesta antes de elegir. El precio es solo una de las diferencias.",
    "orderNote": "Las propuestas aparecen en el orden en que se recibieron. Lumora no las ordena por ranking.",
    "backToRequest": "Volver a la solicitud",
    "empty": {
      "title": "Aún no hay propuestas",
      "description": "Cuando los técnicos envíen propuestas, aparecerán aquí para compararlas."
    },
    "details": "Cada propuesta en detalle",
    "type": {
      "fixed": "Precio cerrado",
      "estimate": "Estimación",
      "visit_required": "Requiere visita"
    },
    "state": {
      "current": "Actual",
      "needs_reconfirmation": "Debe reconfirmarse",
      "expired": "Vencida",
      "withdrawn": "Retirada",
      "selected": "Elegida",
      "not_selected": "No elegida"
    },
    "why": {
      "needs_reconfirmation": "Esta propuesta se basa en una versión anterior de la solicitud. El técnico debe reconfirmarla antes de que puedas elegirla.",
      "expired": "Esta propuesta venció y no se puede elegir.",
      "withdrawn": "El técnico retiró esta propuesta.",
      "selected": "Esta propuesta fue elegida.",
      "not_selected": "Se eligió otra propuesta.",
      "request_draft": "La solicitud es un borrador, así que todavía no se pueden elegir propuestas.",
      "request_selected": "Ya se eligió una propuesta en esta solicitud.",
      "request_completed": "Esta solicitud está completada.",
      "request_cancelled": "Esta solicitud fue cancelada."
    },
    "version": "Versión {{number}}",
    "basedOn": "basada en la versión {{number}} de la solicitud",
    "sentAt": "recibida el {{date}}",
    "price": "Precio",
    "total": {
      "tbd": "Importe por definir",
      "afterVisit": "Importe por definir tras la visita.",
      "knownSubtotal": "Subtotal conocido"
    },
    "scope": "Alcance",
    "exclusions": "Lo que no está incluido",
    "exclusionsNone": "No se informaron exclusiones",
    "notInformed": "No informado",
    "warranty": "Garantía (declarada por el técnico)",
    "availability": "Disponibilidad",
    "validUntil": "Válida hasta",
    "declaredNote": "La garantía, la disponibilidad y la validez las declara el técnico.",
    "visitFee": {
      "label": "Tarifa de visita",
      "none": "Sin tarifa de visita",
      "unknown": "Tarifa de visita no informada"
    },
    "lines": {
      "title": "Conceptos",
      "tbd": "por definir",
      "category": {
        "labor": "Mano de obra",
        "parts": "Repuestos",
        "other": "Otros"
      }
    },
    "versions": {
      "title_one": "Historial de versiones ({{count}} versión)",
      "title_other": "Historial de versiones ({{count}} versiones)",
      "none": "No hay versiones anteriores."
    },
    "compare": {
      "title": "Comparación",
      "note": "Todos los importes están en {{currency}}. Las diferencias de alcance y exclusiones importan tanto como el precio.",
      "caption": "Comparación de propuestas en {{currency}}",
      "criterion": "Criterio",
      "versionAndRevision": "Versión {{version}}, basada en la versión {{revision}} de la solicitud",
      "criteria": {
        "type": "Tipo",
        "price": "Precio",
        "basedOn": "Versión",
        "state": "Estado"
      }
    },
    "select": {
      "action": "Elegir la propuesta de {{name}}",
      "visitAction": "Solicitar la visita de {{name}}",
      "readFirst": "Lee el alcance, las exclusiones y los costos de arriba antes de elegir.",
      "title": "¿Elegir la propuesta de {{name}}?",
      "description": "Estás eligiendo esta propuesta. Las demás quedan como no elegidas, sin que se vean entre sí.",
      "visitTitle": "¿Solicitar la visita de {{name}}?",
      "visitDescription": "Le pides a este técnico que visite y evalúe. El precio no es final y no está aceptado.",
      "acknowledge": "Entiendo que las condiciones finales y la ejecución se acuerdan directamente con el proveedor. Esto no es un contrato ni un pago.",
      "confirm": "Elegir esta propuesta",
      "visitConfirm": "Solicitar la visita",
      "done": "Elección registrada."
    }
  },
  "tech": {
    "footer": "Esta página es privada y se compartió contigo para un presupuesto. Lumora no realiza reparaciones ni garantiza a los proveedores.",
    "requestFrom": "Solicitud de {{name}}",
    "request": "Solicitud de presupuesto",
    "revision": "Versión {{number}}",
    "sharedOn": "Compartida el {{date}}",
    "expiresOn": "Enlace válido hasta el {{date}}",
    "sharedNote": "Solo ves lo que el residente eligió compartir.",
    "gate": {
      "title": "Confirma tu correo",
      "body": "Esta solicitud está vinculada a una identidad verificada. Confirma tu correo para abrirla."
    },
    "invalid": {
      "title": "Enlace no encontrado",
      "body": "Comprueba que copiaste el enlace completo o pide uno nuevo al residente."
    },
    "gone": {
      "invitation_revoked": {
        "title": "Acceso finalizado",
        "body": "El residente finalizó tu acceso a esta solicitud. Si crees que es un error, pide un enlace nuevo."
      },
      "invitation_expired": {
        "title": "Este enlace venció",
        "body": "Pide un enlace nuevo al residente si todavía quieres enviar una propuesta."
      },
      "request_cancelled": {
        "title": "Solicitud cancelada",
        "body": "El residente canceló esta solicitud. No hace falta nada más de tu parte."
      }
    },
    "respond": {
      "title": "Enviar una propuesta",
      "body": "Para enviar o cambiar una propuesta, confirma tu correo con un código de un solo uso.",
      "verify": "Confirmar mi correo"
    },
    "verify": {
      "why": "Enviamos un código de 6 dígitos a tu correo para confirmar que eres tú. No hace falta crear una cuenta.",
      "hintRestricted": "{{hint}}",
      "email": "Tu correo",
      "sendCode": "Enviar código",
      "sent": "Enviamos un código de 6 dígitos a {{email}}. Es válido por 10 minutos.",
      "resent": "Enviamos un código nuevo.",
      "code": "Código",
      "codeHint": "Seis dígitos.",
      "codeFormat": "Escribe los 6 dígitos.",
      "name": "Tu nombre",
      "company": "Empresa",
      "confirm": "Confirmar",
      "resend": "Enviar el código de nuevo",
      "resendIn": "Enviar de nuevo en {{seconds}} s",
      "waitToRetry": "Espera {{seconds}} s para intentarlo de nuevo.",
      "changeEmail": "Usar otro correo"
    },
    "quote": {
      "title": "Tu propuesta",
      "formTitle": "Formulario de la propuesta",
      "reconfirmTitle": "Reconfirmar tu propuesta",
      "send": "Enviar propuesta",
      "sendNewVersion": "Enviar nueva versión",
      "reconfirm": "Reconfirmar propuesta",
      "reconfirmStart": "Revisar y reconfirmar",
      "sendAgain": "Enviar una propuesta nueva",
      "newVersion": "Editar y enviar una nueva versión",
      "sent": "Propuesta enviada.",
      "notOpen": "Esta solicitud ya no está abierta para propuestas.",
      "withdraw": "Retirar propuesta",
      "withdrawTitle": "¿Retirar tu propuesta?",
      "withdrawDescription": "El residente ya no podrá elegirla. Puedes enviar una nueva versión más adelante si la solicitud sigue abierta.",
      "withdrawnNote": "Retiraste esta propuesta. Si envías una nueva versión, vuelve a estar disponible.",
      "needsReconfirmTitle": "La información de la solicitud cambió",
      "needsReconfirmBody": "Tu propuesta se basa en una versión anterior. Revisa la información de arriba (versión {{number}}) y reconfírmala.",
      "outdatedTitle": "La información de la solicitud cambió",
      "outdatedBody": "Revisa la información actualizada de arriba, ajusta tu propuesta si hace falta y envíala de nuevo. Tus respuestas siguen aquí.",
      "currencyNote": "Todos los importes están en {{currency}}, la moneda de la solicitud.",
      "type": "Tipo de propuesta",
      "typeHint": {
        "fixed": "Un precio cerrado para el alcance descrito.",
        "estimate": "Un precio aproximado que puede cambiar. Marca los conceptos que todavía no puedes valorar.",
        "visit_required": "Necesitas visitar antes de poner precio."
      },
      "scopeHint": "Lo que vas a hacer, en palabras sencillas.",
      "exclusionsHint": "Lo que no está incluido, para evitar sorpresas.",
      "lines": {
        "empty": "Aún no hay conceptos.",
        "item": "Concepto {{number}}",
        "category": "Categoría",
        "description": "Descripción",
        "quantity": "Cantidad",
        "quantityInvalid": "Usa un número entero de 1 o más.",
        "price": "Precio unitario ({{currency}})",
        "unknown": "Precio por definir",
        "lineTotal": "Total del concepto",
        "add": "Agregar concepto",
        "remove": "Quitar el concepto {{number}}",
        "removeShort": "Quitar",
        "max": "Llegaste al límite de {{max}} conceptos.",
        "needOne": "Agrega al menos un concepto o elige “Requiere visita”.",
        "fix": "Corrige los conceptos marcados abajo."
      },
      "fixedUnknown": "Un precio cerrado no debería tener conceptos por definir. Considera elegir “Estimación”.",
      "preview": "Vista previa del total",
      "previewUnknown": "Al menos un concepto aún no tiene precio, así que el total queda por definir.",
      "previewNote": "Se muestra para ayudarte. Lumora calcula los valores finales al enviar.",
      "fee": {
        "none": "Sin tarifa de visita",
        "known": "Hay tarifa de visita",
        "unknown": "Hay tarifa de visita, pero aún no sé el importe",
        "amount": "Importe de la tarifa de visita ({{currency}})",
        "unknownNote": "El residente verá que la tarifa existe pero no fue informada."
      },
      "warrantyHint": "Describe la garantía que ofreces, si la hay.",
      "notContract": "Enviar una propuesta no es un contrato. Las condiciones finales se acuerdan directamente con el residente."
    },
    "outcome": {
      "quote_selected": {
        "title": "Tu propuesta fue elegida",
        "body": "El residente acordará contigo directamente las condiciones finales. Esto no es un contrato ni un pago."
      },
      "visit_requested": {
        "title": "El residente solicitó tu visita",
        "body": "Es una solicitud de visita de evaluación, no la aceptación de un precio final."
      },
      "not_selected": {
        "title": "No elegida esta vez",
        "body": "El residente eligió otra opción. Gracias por responder."
      }
    },
    "service": {
      "title": "Registrar el servicio realizado",
      "correctTitle": "Corregir el registro del servicio",
      "intro": "Tu presupuesto fue elegido. Cuando el trabajo esté hecho, regístralo aquí para que el residente lo confirme.",
      "list": "Tus registros de servicio",
      "date": "Fecha del servicio",
      "description": "Qué se hizo",
      "descriptionHint": "Describe el trabajo de forma objetiva.",
      "parts": "Piezas usadas",
      "cost": "Valor cobrado",
      "warrantyUntil": "Garantía hasta",
      "warrantyNotes": "Condiciones de la garantía",
      "notice": "El residente lo revisará y confirmará. Hasta entonces, el registro queda como “esperando confirmación”.",
      "send": "Enviar para confirmación",
      "resend": "Reenviar corregido",
      "sent": "Enviado para confirmación del residente.",
      "pendingNote": "El residente aún debe confirmar este registro.",
      "confirmedNote": "El residente confirmó este registro.",
      "correctionAsked": "El residente pidió una corrección.",
      "reason": "Motivo: {{reason}}",
      "correct": "Corregir registro",
      "stale": "Este registro ya cambió. Recarga la página para ver la versión actual.",
      "status": {
        "pending_confirmation": "Esperando confirmación",
        "correction_requested": "Corrección solicitada",
        "confirmed": "Confirmado por el residente"
      }
    }
  },
  "notifications": {
    "title": "Notificaciones",
    "bell": "Notificaciones",
    "bellUnread_one": "Notificaciones, {{count}} sin leer",
    "bellUnread_other": "Notificaciones, {{count}} sin leer",
    "unreadCount_one": "{{formatted}} sin leer",
    "unreadCount_other": "{{formatted}} sin leer",
    "allRead": "Todo leído.",
    "markAll": "Marcar todas como leídas",
    "onlyUnread": "Mostrar solo las no leídas",
    "unread": "Sin leer",
    "markReadHint": "Ábrela para marcarla como leída.",
    "empty": {
      "title": "Aún no hay notificaciones",
      "description": "Los avisos de presupuestos, servicios y recordatorios aparecen aquí."
    },
    "emptyUnread": {
      "title": "Nada por leer",
      "description": "Estás al día."
    },
    "fallback": {
      "someone": "Alguien"
    },
    "prefs": {
      "title": "Notificaciones",
      "description": "Para cada tipo de aviso, elige si lo quieres en la app y por correo.",
      "inApp": "En la app",
      "email": "Por correo",
      "types": {
        "quote_received": "Presupuesto recibido",
        "quote_updated": "Presupuesto actualizado",
        "request_selected_confirmation": "Elección de presupuesto",
        "request_cancelled": "Solicitud cancelada",
        "service_confirmation_needed": "Servicio esperando confirmación",
        "service_record_corrected": "Servicio corregido por el prestador",
        "reminder_due": "Recordatorio vencido",
        "warranty_expiring": "Garantía por terminar",
        "export_ready": "Exportación lista",
        "ownership_transfer_requested": "Solicitud de transferencia",
        "member_joined": "Nuevo miembro",
        "extraction_budget_warning": "Límite de lectura de documentos"
      }
    },
    "types": {
      "unknown": {
        "title": "Novedad en la casa",
        "body": "Ábrela para ver."
      },
      "quote_received": {
        "title": "Presupuesto recibido",
        "body": "{{technician}} envió un presupuesto para “{{request_title}}”."
      },
      "quote_updated": {
        "title": "Presupuesto actualizado",
        "body": "{{technician}} actualizó el presupuesto de “{{request_title}}”."
      },
      "request_selected_confirmation": {
        "title": "Elección registrada",
        "body_quote_selected": "{{selected_by}} eligió un presupuesto en “{{request_title}}”.",
        "body_visit_requested": "{{selected_by}} pidió una visita en “{{request_title}}”."
      },
      "request_cancelled": {
        "title": "Solicitud cancelada",
        "body": "{{cancelled_by}} canceló la solicitud “{{request_title}}”."
      },
      "service_confirmation_needed": {
        "title": "Servicio espera confirmación",
        "body": "{{provider}} informó el servicio de “{{request_title}}”. Confírmalo o pide una corrección."
      },
      "service_record_corrected": {
        "title": "Servicio corregido",
        "body": "{{provider}} corrigió el servicio de “{{request_title}}”. Revísalo de nuevo."
      },
      "reminder_due": {
        "title": "Recordatorio",
        "body": "“{{title}}” vence el {{due_on}}."
      },
      "warranty_expiring": {
        "title": "Garantía por terminar",
        "body": "La garantía de {{asset_name}} que declaraste termina el {{warranty_until}}."
      },
      "export_ready": {
        "title": "Exportación lista",
        "body": "La exportación de {{household_name}} está lista para descargar durante 24 horas."
      },
      "ownership_transfer_requested": {
        "title": "Solicitud de transferencia",
        "body": "{{from}} quiere transferirte la propiedad de {{household_name}}."
      },
      "member_joined": {
        "title": "Nuevo miembro",
        "body": "{{member}} se unió a {{household_name}}."
      },
      "extraction_budget_warning": {
        "title": "Lectura de documentos cerca del límite",
        "body": "{{household_name}} usó {{used}} de {{limit}} lecturas del mes."
      }
    },
    "filterAll": "Todas",
    "filterUnread": "No leídas"
  },
  "reminders": {
    "title": "Recordatorios",
    "subtitle": "Fechas que quieres recordar. Nada se completa solo: tú lo marcas como hecho.",
    "new": "Nuevo recordatorio",
    "state": {
      "upcoming": "Próximo",
      "due_today": "Vence hoy",
      "overdue": "Atrasado",
      "finished": "Terminado"
    },
    "source": {
      "warranty": "Garantía"
    },
    "warrantyReason": "Aviso automático antes del fin de la garantía que declaraste.",
    "recurrence": {
      "once": "Una vez",
      "days_one": "Cada {{count}} día",
      "days_other": "Cada {{count}} días",
      "months_one": "Cada {{count}} mes",
      "months_other": "Cada {{count}} meses"
    },
    "when": {
      "today": "hoy",
      "in_one": "en {{count}} día",
      "in_other": "en {{count}} días",
      "late_one": "{{count}} día de atraso",
      "late_other": "{{count}} días de atraso"
    },
    "finishedOn": "Terminado el {{date}}",
    "lastDone": "Última vez hecho el {{date}}",
    "count_one": "{{formatted}} recordatorio",
    "count_other": "{{formatted}} recordatorios",
    "filters": {
      "status": "Situación",
      "statuses": {
        "active": "Activos",
        "overdue": "Atrasados",
        "upcoming": "Próximos",
        "finished": "Terminados"
      },
      "asset": "Equipo o área",
      "assetAll": "Todos los elementos",
      "assetSelected": "Elemento seleccionado"
    },
    "empty": {
      "title": "Aún no hay recordatorios",
      "description": "Crea un recordatorio para un cambio de filtro, una revisión o cualquier fecha importante. Tú eliges la frecuencia."
    },
    "noResults": {
      "title": "Ningún recordatorio con estos filtros",
      "description": "Prueba otra situación u otro elemento.",
      "clear": "Limpiar filtros"
    },
    "complete": {
      "action": "Marcar como hecho",
      "title": "Marcar “{{title}}” como hecho",
      "description": "Indica cuándo se hizo. Queda registrado.",
      "date": "Fecha en que se hizo",
      "note": "Observación",
      "confirm": "Marcar como hecho",
      "nextOnce": "Este recordatorio es de una sola vez: al marcarlo, queda terminado.",
      "nextInterval": "La próxima fecha será {{date}}, contada desde {{from}}.",
      "nextIntervalUnknown": "La próxima fecha se calcula a partir de la fecha indicada.",
      "done": "Recordatorio marcado como hecho.",
      "conflict": "Este recordatorio cambió o ya se terminó. Cierra y revisa la lista actualizada."
    },
    "form": {
      "editCrumb": "Editar",
      "editTitle": "Editar recordatorio",
      "titleLabel": "¿Qué recordar?",
      "titleHint": "Por ejemplo “Cambiar el filtro del purificador”.",
      "asset": "Equipo o área",
      "noAsset": "Ningún elemento",
      "firstDate": "Primera fecha",
      "nextDate": "Próxima fecha",
      "dateHint": "Día en el calendario de la casa. Hoy es {{today}}.",
      "repeat": "¿Repetir?",
      "once": "Solo una vez",
      "interval": "Repetir en intervalos que yo elija",
      "chooseRepeat": "Elige una opción.",
      "every": "¿Cada cuánto?",
      "everyInvalid": "Usa un número entero de 1 a 120.",
      "unit": "Unidad",
      "unitChoose": "Elige la unidad",
      "units": {
        "days": "días",
        "months": "meses"
      },
      "intervalNote": "Después de marcarlo como hecho, la próxima fecha cuenta desde el día en que se hizo.",
      "notes": "Observaciones",
      "create": "Crear recordatorio",
      "saved": "Recordatorio guardado.",
      "conflict": "Otra persona cambió este recordatorio. Recarga la página e inténtalo de nuevo.",
      "warrantyManaged": "Este recordatorio de garantía se mantiene desde el equipo. Para cambiarlo, edita la garantía del elemento.",
      "openAsset": "Editar el equipo"
    },
    "delete": {
      "title": "Eliminar recordatorio",
      "description": "El recordatorio deja de avisar. El historial de servicios del elemento no cambia.",
      "action": "Eliminar recordatorio",
      "confirmTitle": "¿Eliminar “{{title}}”?",
      "confirm": "Esta acción no se puede deshacer.",
      "done": "Recordatorio eliminado."
    }
  }
}
